import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { DestTransferStrategy } from "features/WorklistTools/Nucleofection/NucleofectionInterfaces";
import { useNucleofectionStateProvider } from "features/WorklistTools/Nucleofection/state/StateProvider";

interface DestTransferStrategyProps {
  handleDestTransferStrategyChanged: (key: string, value: string) => void;
  isDisabled: boolean;
}

export const DestPlateTransferStrategy = ({
  handleDestTransferStrategyChanged,
  isDisabled,
}: DestTransferStrategyProps) => {
  const { nucleofectionInternalState } = useNucleofectionStateProvider();

  const methodSettings = nucleofectionInternalState.methodSettings;

  const DestTransferStratOptions = Object.values(DestTransferStrategy).filter(
    (strat) => strat !== DestTransferStrategy.NotSelected
  );

  const hasError = methodSettings.destTransferStrategy === "";

  const ToolTipContent = (
    <Box>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: "bold",
        }}
      >
        Int to Dest Transfer Volume Strategy
      </Typography>
      <List
        sx={{
          listStyleType: "disc",
          pl: 3,
          m: 0,
          fontSize: "12px",
          lineHeight: 1.33,
        }}
      >
        <ListItem
          sx={{
            display: "list-item",
            py: 0,
          }}
        >
          <ListItemText
            disableTypography
            primary="Split Evenly: Equal transfer volumes across all dest plates"
          />
        </ListItem>
        <ListItem
          sx={{
            display: "list-item",
            py: 0,
          }}
        >
          <ListItemText
            disableTypography
            primary="Maximize: Fill each dest plate (in order) with maximum possible volume"
          />
        </ListItem>
        <ListItem
          sx={{
            display: "list-item",
            py: 0,
          }}
        >
          <ListItemText
            disableTypography
            primary="Custom: User-inputted transfer volumes"
          />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <FormControl variant="outlined" fullWidth error={hasError}>
      <InputLabel id="dest-transfer-strategy-label" shrink>
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          Dest Plate Transfer Strategy
          <Tooltip arrow placement="top" title={ToolTipContent}>
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </InputLabel>
      <Select
        labelId="dest-transfer-strategy-label"
        value={methodSettings.destTransferStrategy}
        input={
          <OutlinedInput notched label="Dest Plate Transfer Strategy ------" />
        }
        variant="outlined"
        onChange={(e) =>
          handleDestTransferStrategyChanged(
            "destTransferStrategy",
            e.target.value
          )
        }
        disabled={isDisabled}
      >
        {DestTransferStratOptions.map((strategy) => (
          <MenuItem value={strategy}>{strategy}</MenuItem>
        ))}
      </Select>
      {hasError ? <FormHelperText>Required</FormHelperText> : null}
    </FormControl>
  );
};
